import { render } from "./ChoixPoste.vue?vue&type=template&id=6c3eae00&scoped=true"
import script from "./ChoixPoste.vue?vue&type=script&lang=js"
export * from "./ChoixPoste.vue?vue&type=script&lang=js"

import "./ChoixPoste.vue?vue&type=style&index=0&id=6c3eae00&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3eae00"]])

export default __exports__